import { useSecondaryMenu } from 'ui/components/BPLayout'
import { PageV2 } from 'ui/components/Page'
import { PageSectionCommon } from 'ui/components/Page/PageSectionCommon'
import { Warning } from 'ui/components/Warning'

import { AddBankAccountsDialog } from '../../components/AddBankAccountsDialog'
import {
  Actions,
  ApplicationControls,
  CompanyDetails,
  ContactWithTheApplicant,
  DocumentsList,
  GeneralInformation,
  InternalDocuments,
  Reviews
} from './components'
import { DocumentsListIsolated } from './components/DocumentListIsolated'
import { OnboardingDocumentsList } from './components/OnboardingDocumentsList'
import useApplicationDetails from './useApplicationDetails'

const ApplicationDetails = () => {
  const { application, isShowBankAccountsDialog, onFinalizeApplication, isFinalizing, onCancel, onSubmit } =
    useApplicationDetails()

  const {
    relationships,
    enableClientDocuments,
    enableReviews,
    showOnboardingDocuments,
    titleOverline,
    title,
    infoIsApplicationActive,
    enableApplicationInProgressWarning,
    isIsolatedApplicationFromEntities,
    applicationID
  } = application

  const bankAccountDialogState = {
    applicationId: applicationID,
    showDialog: isShowBankAccountsDialog,
    isFinalizing: isFinalizing,
    onCancel: onCancel,
    onSubmit: onSubmit
  }

  useSecondaryMenu([
    { label: 'General Information', hash: 'general' },
    { label: 'Contact with the Applicant', hash: 'contact' },
    ...(relationships.length
      ? relationships.map((_, i) => ({
          label: `Company #${i + 1}`,
          hash: `company_${i + 1}`
        }))
      : []),
    {
      label: 'Document Uploading',
      hash: 'client-documents',
      disabled: !enableClientDocuments
    },
    { label: 'Reviews', hash: 'reviews', disabled: !enableReviews },
    { label: 'Internal Documents', hash: 'internal-documents' },
    ...(showOnboardingDocuments ? [{ label: 'Onboarding Documents', hash: 'onboarding-documents' }] : [])
  ])

  return (
    <PageV2
      title={titleOverline}
      subTitle={title}
      face={infoIsApplicationActive ? 'secondary' : 'disabled'}
      actions={<Actions application={application} />}
      footer={
        <ApplicationControls
          application={application}
          isFinalizing={isFinalizing}
          onFinalizeApplication={onFinalizeApplication}
        />
      }
    >
      {isShowBankAccountsDialog && <AddBankAccountsDialog state={bankAccountDialogState} />}
      {enableApplicationInProgressWarning && (
        <PageSectionCommon>
          <Warning
            title="Application in progress"
            description="Please wait for the client to finish filling out the application."
          />
        </PageSectionCommon>
      )}
      <GeneralInformation item={application} />
      <ContactWithTheApplicant application={application} />
      <CompanyDetails application={application} />
      {enableClientDocuments && !isIsolatedApplicationFromEntities && (
        <DocumentsList application={application} companies={relationships || []} />
      )}
      {enableClientDocuments && isIsolatedApplicationFromEntities && (
        <DocumentsListIsolated application={application} companies={relationships || []} />
      )}
      <section id="reviews">{enableReviews && <Reviews application={application} />}</section>
      <InternalDocuments application={application} />
      {showOnboardingDocuments && <OnboardingDocumentsList application={application} />}
    </PageV2>
  )
}

export default ApplicationDetails
